import React, { useEffect, useState, useCallback } from 'react'
import { useAppContext } from '@/components/AppContext'
import withDefaultLayout from '@/hoc/WithDefaultLayout'
import PoojaOrdersPage from '../PoojaOrders/components/PoojaOrdersPage'
import OrderDetailsForm from './components/OrderDetailsForm'
import { CreateStore, Order, SendNotification } from '@a4b/api/src/modules/Monetisation/Offerings/types'
import styled from 'styled-components'
import { useForm } from 'antd/lib/form/Form'
import { YODA_CDN_URL, YODA_PRESIGN_URL } from '@/utils/constants'
import {
    Card,
    Col,
    Input,
    Modal,
    Row,
    Select,
    Space,
    Tag,
    message,
    Typography,
    Radio
} from 'antd'

import { deliveryStatusFilters, orderStatusFilters, orderTypeFilterOptions, parseOrders } from './utils/helper'
import { useSearchParams } from 'react-router-dom'
import { KaggUserPropertyPayload } from '@/../../../packages/a4b-api/src/modules/Kagg/type'
import { openErrorNotification } from '@/utils'
const { Text } = Typography

const { Search } = Input
const Container = styled(Card)`
  display: flex;
  flex-direction: column;
  margin-top: 60px;

  .ant-card-body {
    flex-grow: 1;
  }
  .ant-card-head-wrapper {
    display: block;
    width: 100%;
  }
  .ant-card-head-title {
    flex-basis: 30%;
    padding-bottom: 0px;
  }
  .ant-card-extra {
    flex-basis: 70%;
  }
`
const LabelRightAlign = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: end;
  align-items: center;
  height: 100%;
`
interface FiltersType {
    serviceType: string
    orderStatus: string
    bookingId: string
    contactNumber: string
    userId: string
    storeId: string | undefined
    bookingWhatsAppNumber: string
    bookingMemberData: string
    deliveryStatus: string
    bookingAddress: string
}

const actionMapping: any = {
    offeringUserName: "UPDATE_OFFERING_USER_NAME",
    memberData: "UPDATE_BOOKING_MEMBER_DATA",
    sku: "UPDATE_INVENTORY_VIDEO",
    address: "UPDATE_PRASAD_DETAILS",
    refund: "UPDATE_ORDER_STATUS_REFUND",
    whatsappNumber: "UPDATE_WHATSAPP_NUMBER",
    trackingData: "UPDATE_TRACKING_DATA",
    delivery_status: "UPDATE_DELIVERY_STATUS"
}

const PoojaOrders = () => {
    const { networkInstance, monetisationRoles, userProfile } = useAppContext()
    const { monetisationOfferingsApi, kagg } = networkInstance.clientWithHeaders
    const [orderDetailsForm] = useForm()
    const [orderData, setOrderData] = useState<Order[]>()
    const [messageApi, contextHolder] = message.useMessage()
    const [loading, setLoading] = useState<boolean>(true)
    const [showOrderDetailsForm, setShowOrderDetailsForm] = useState<boolean>(false)
    const [editOrder, setEditOrder] = useState<any>()
    const [currentOrder, setCurrentOrder] = useState<any>()
    const [showConfirmationModal, setShowConfirmationModal] = useState(false)
    const [remark, setRemark] = useState<string>('')
    const [pageNumber, setPageNumber] = useState<number | null>(1)
    const [isLastPage, setIsLastPage] = useState<boolean>(false)
    const [userId, setUserId] = useState<string>('');
    const [storeList, setStoreList] = useState<CreateStore[]>([])
    const [isUserPropLoading, setIsUserPropLoading] = useState(false)
    const [searchParams] = useSearchParams()
    const [filters, setFilters] = useState<FiltersType>({
        serviceType: 'offerings',
        orderStatus: 'booked',
        bookingId: '',
        contactNumber: '',
        userId: '',
        bookingWhatsAppNumber: '',
        bookingMemberData: '',
        storeId: undefined,
        deliveryStatus: '',
        bookingAddress: '',
    })

    const getStoreList = useCallback((async () => {
        try {
            let filterServiceType = filters?.serviceType
            if (filterServiceType === 'offerings_delivery') {
                filterServiceType = 'offerings'
            }

            const storeList = await monetisationOfferingsApi.storesApi.getStoreList(
                undefined,
                'dropdown',
                searchParams.get("country_code") || "IN",
                undefined,
                searchParams.get("language_code") || "hi",
                undefined,
                undefined,
                undefined,
                filterServiceType
            )

            setStoreList(storeList?.data?.data?.store_list)
            if (storeList?.data?.data?.store_list?.length > 0) {
                setFilters(prevFilters => ({
                    ...prevFilters,
                    storeId: storeList?.data?.data?.store_list?.[0]?.id
                }))
            }

        } catch (error) {

            message.error({
                content: 'Failed to fetch store list',
                duration: 3,
            })
            console.log(error)
        }
    }), [filters?.serviceType, monetisationOfferingsApi.storesApi, searchParams])


    useEffect(() => {
        getStoreList()
    }, [getStoreList])

    const getPoojaOrders = useCallback(async () => {
        setLoading(true)
        try {
            let filterServiceType = filters?.serviceType
            if (filterServiceType === 'offerings_delivery') {
                filters.storeId = undefined
                filterServiceType = 'offerings'
            }

            const orderResponse = await monetisationOfferingsApi.orderApi.getOrders(
                String(pageNumber),
                filters.orderStatus,
                filters.serviceType,
                filters.bookingId,
                filters.contactNumber,
                filters.userId,
                filters.storeId!,
                filters.bookingWhatsAppNumber,
                filters.bookingMemberData,
                filters.deliveryStatus,
                filters.bookingAddress
            )

            const parsedOrderData = parseOrders(orderResponse?.data?.data, filterServiceType)
            setIsLastPage(orderResponse?.data?.data?.is_last_page)
            setOrderData(parsedOrderData)
            setLoading(false)
        } catch (error) {
            setLoading(false)
            setPageNumber(null)
            console.log("Error: ", error)
        }
    }, [filters?.orderStatus, filters.bookingId, filters.bookingWhatsAppNumber, filters.contactNumber, filters.serviceType, filters.storeId, filters.userId, filters.bookingMemberData, filters.deliveryStatus, filters.bookingAddress, monetisationOfferingsApi.orderApi, pageNumber])

    useEffect(() => {
        if (filters?.storeId || filters?.serviceType === 'offerings_delivery')
            getPoojaOrders()
    }, [filters?.storeId, filters?.serviceType, getPoojaOrders])

    useEffect(() => {
        if (filters?.deliveryStatus)
            getPoojaOrders()
    }, [filters?.deliveryStatus, getPoojaOrders])

    const sendNotification = async (record: any) => {
        const notificationPayload: SendNotification = {
            type: "trigger-event",
            event_properties: {
                order_id: record?.id,
                event_name: "puja_sankalp_form_not_filled_backend"
            }
        }
        try {
            await monetisationOfferingsApi.systemApi.triggerEvent(notificationPayload)
            messageApi.open({
                type: 'success',
                content: 'Notification has been sent',
            });
        } catch (error) {
            console.log("Error while sending notification ", error)
        }
    }


    const handleTableChange = (type: string) => {
        if (type === 'previous' && pageNumber! > 1) {
            setPageNumber(pageNumber! - 1)
        } else if (type === 'next' && !isLastPage) {
            setPageNumber(pageNumber! + 1)
        }
    }

    const filterOrders = (type: string, value: string) => {
        setPageNumber(1)
        setFilters((prevFilters: FiltersType) => ({
            ...prevFilters,
            [type]: value,
            bookingMemberData: '',
            ...(type === 'serviceType' && value === 'offerings_delivery' ? { storeId: undefined } : {})
        }))
    }


    const closeOrderDetailsForm = (isOrderUpdated?: boolean) => {
        setShowOrderDetailsForm(false)
        orderDetailsForm?.resetFields()
        if (isOrderUpdated)
            setTimeout(() => {
                getPoojaOrders()
            }, 500)
    }

    const triggerEdit = (value: any) => {
        let filterServiceType = filters?.serviceType
        if (filterServiceType === 'offerings_delivery') {
            filterServiceType = 'offerings'
        }

        const orderData = { ...value, service_type: filterServiceType }
        setShowOrderDetailsForm(true)
        setEditOrder(orderData)
    }

    const handleRefund = (value: any) => {
        setCurrentOrder(value)
        setShowConfirmationModal(true)
    }

    const onModalOk = async () => {
        if (remark?.length <= 0) {
            message?.warning('Remark is required!')
        } else {
            if (monetisationRoles?.user_type === 'super_admin') {
                try {
                    await monetisationOfferingsApi.orderApi.updateOrder(
                        currentOrder?.id,
                        actionMapping?.['refund'],
                        { user_email: userProfile?.email!, remarks: remark }
                    )
                    message.success('Order has been successfully marked as refunded!')
                    setTimeout(() => {
                        getPoojaOrders()
                    }, 500)
                    setRemark('')
                    onModalCancel()
                } catch (e) {
                    message.error('Error while updating refund status!')
                    onModalCancel()
                    console.log(e)
                }
            } else {
                message.warning('Need Super Admin Access to mark as refund!')
                onModalCancel()
            }
        }

    }

    const onModalCancel = () => {
        setRemark('')
        setShowConfirmationModal(false)
    }

    const handleUpdateOrders = useCallback(() => {
        setTimeout(() => {
            getPoojaOrders()
        }, 2000)
    }, [getPoojaOrders])

    const fetchUserIdByContact = async (contactNumber: string) => {
        try {
            setIsUserPropLoading(true)
            const payload: KaggUserPropertyPayload = {
                contact_numbers: [contactNumber]
            }
            const response = await kagg.getUserData(payload)
            return response?.data?.data?.users?.[0]?.user_id
        } catch (error) {
            openErrorNotification(error)
            return
        } finally {
            setIsUserPropLoading(false)
        }
    };

    const validateContactNumber = (value: string): string | null => {
        if (value) {
            if (value.length !== 10 || isNaN(Number(value))) {
                message.error('Please enter a valid 10-digit contact number.')
                return null
            }
            return `+91${value}`

        }
        return null
    }

    const handleContactSearch = async (value: string) => {
        if (!value) {
            setFilters(prev => ({
                ...prev,
                userId: '',
                storeId: storeList?.[0]?.id,
                orderStatus: 'booked',
            }))
            setUserId('')
            return
        }

        const formattedValue = validateContactNumber(value)
        if (!formattedValue) { return }

        const userId = await fetchUserIdByContact(formattedValue)
        if (!userId) {
            message.warning('Contact number not found.');
            return
        }

        setFilters(prev => ({
            ...prev,
            userId: userId,
            storeId: 'any',
            orderStatus: 'any',
        }))
        setUserId(userId)
    }

    const handleBookingAndUserIdSearch = async (value: string, type: 'bookingId' | 'userId') => {
        const searchType = type === 'bookingId' ? 'Booking Id' : 'User Id'

        const numValue = Number(value)
        if (isNaN(numValue)) {
            message.error(`${searchType} must be a valid number`)
            return;
        }

        if (value && numValue === 0) {
            message.error(`${searchType} cannot be 0`)
            return;
        }
        setFilters(prev => ({
            ...prev,
            [type]: value,
            storeId: value ? 'any' : storeList?.[0]?.id,
            orderStatus: value ? 'any' : 'booked'
        }))
    }

    return (
        <div style={{ padding: '0 20px' }}>
            <Container
                title='Manage Orders'
                style={{ width: '100%', display: 'flex', flexDirection: 'column' }
                }
                extra={
                    <div style={{ display: 'flex', flexDirection: 'column' }}>
                        <Row style={{ width: '100%', display: 'flex', flexDirection: 'row' }}>
                            <Select
                                size='middle'
                                placeholder="Order type"
                                style={{ width: '12%', marginRight: '10px' }}
                                defaultValue={filters?.serviceType}
                                options={orderTypeFilterOptions.map((item: any) => ({
                                    label: item.label,
                                    value: item.value
                                }))}
                                onChange={(value: string) => {
                                    filterOrders('serviceType', value)
                                }}
                            />
                            {filters?.serviceType === 'offerings_delivery' && (
                                <Select
                                    size='middle'
                                    placeholder="Delivery status"
                                    style={{ width: '12%', marginRight: '10px' }}
                                    allowClear
                                    options={deliveryStatusFilters.map((item: any) => ({
                                        label: item.label,
                                        value: item.value
                                    }))
                                    }
                                    onChange={(value: string) => {
                                        filterOrders('deliveryStatus', value)
                                    }}
                                />
                            )}
                            <Search
                                placeholder='Booking Id'
                                style={{ width: '10%', marginRight: '10px' }}
                                onSearch={(value) => handleBookingAndUserIdSearch(value, 'bookingId')}
                                allowClear
                            />
                            <Search
                                placeholder='UserId'
                                style={{ width: '10%', marginRight: '10px' }}
                                value={userId}
                                onChange={(e) => setUserId(e?.target?.value)}
                                onSearch={(value) => handleBookingAndUserIdSearch(value, 'userId')}
                                allowClear
                            />
                            <Search
                                placeholder='Contact Number'
                                style={{ width: '16%', marginRight: '10px' }}
                                addonBefore='+91'
                                maxLength={10}
                                minLength={10}
                                inputMode='numeric'
                                onSearch={handleContactSearch}
                                allowClear
                                loading={isUserPropLoading}
                            />
                            {filters?.serviceType !== 'offerings_delivery' && (
                                <Select value={filters['storeId']} showSearch style={{ width: '24%', marginRight: '10px' }} onChange={(value: string) => {
                                    filterOrders('storeId', value)
                                }}>
                                    <Select.Option key="any" value="any" disabled >Any</Select.Option>
                                    {
                                        storeList?.map((store: CreateStore) => (
                                            <Select.Option key={store.id} value={store.id}>
                                                {store.title}
                                            </Select.Option>
                                        ))
                                    }
                                </Select>
                            )}
                            <Select
                                size='middle'
                                placeholder="Order Status"
                                style={{ width: '9%', marginRight: '10px' }}
                                value={filters?.orderStatus ?? 'any'}
                                options={
                                    orderStatusFilters.map((item: any) => ({
                                        label: item.label,
                                        value: item.value,
                                        disabled: item.disabled
                                    }))
                                }
                                onChange={(value: string) => {
                                    filterOrders('orderStatus', value)
                                }}
                            />
                            <Search
                                placeholder='WhatsApp Number'
                                style={{ width: '13%', marginRight: '10px' }}
                                onSearch={(value: string) => {
                                    filterOrders('bookingWhatsAppNumber', value)
                                }}
                                allowClear
                            />
                        </Row>
                        <div style={{ marginTop: '10px' }}>
                            <Row style={{ width: '100%', display: 'flex', flexDirection: 'row' }}>
                                {filters?.serviceType === 'offerings_delivery' && <div style={{ display: 'flex' }}>
                                    <div style={{ display: 'flex', alignItems: 'center', width: '100%' }}>
                                        <span>
                                            Address filled:
                                        </span>
                                        <div style={{ marginLeft: '10px', display: 'flex' }}>
                                            <Radio.Group
                                                defaultValue={filters?.bookingAddress}
                                                onChange={(e) => {
                                                    filterOrders('bookingAddress', e.target.value)
                                                }}
                                                buttonStyle="solid"
                                                optionType="button"
                                            >
                                                <Radio.Button value="false">Yes</Radio.Button>
                                                <Radio.Button value="true">No</Radio.Button>
                                                <Radio.Button value="">Both</Radio.Button>
                                            </Radio.Group>
                                        </div>
                                    </div>
                                </div>}
                            </Row>
                        </div>
                    </div>
                }
            >
                <Space direction={'vertical'} style={{ width: '100%' }}></Space>
                <Row>
                    <Col span={28}>
                        {contextHolder}
                        <PoojaOrdersPage
                            orderData={orderData}
                            handleTableChange={handleTableChange}
                            sendNotification={sendNotification}
                            filters={filters}
                            triggerEdit={triggerEdit}
                            refundHandler={handleRefund}
                            userRole={monetisationRoles?.user_type!}
                            loading={loading}
                            currentPage={pageNumber}
                        />
                    </Col>
                </Row>
                <LabelRightAlign>
                </LabelRightAlign>
                <OrderDetailsForm
                    showItemCreation={showOrderDetailsForm}
                    closeItemCreation={closeOrderDetailsForm}
                    form={orderDetailsForm}
                    initialValues={editOrder}
                    cdnUrl={YODA_CDN_URL}
                    preSignUrl={YODA_PRESIGN_URL}
                    userRole={monetisationRoles?.user_type!}
                    handleUpdateOrders={handleUpdateOrders}
                />
                <Modal
                    title='Refund Confirmation'
                    visible={showConfirmationModal}
                    onOk={onModalOk}
                    onCancel={onModalCancel}
                    okText=' Yes'
                >
                    <div style={{ display: 'flex', flexDirection: 'column', height: '100%' }}>
                        <span>Order Id: <Tag color='blue'>{currentOrder?.id}</Tag></span>
                        <input
                            value={remark}
                            onChange={(e) => setRemark(e.target.value)}
                            placeholder='Enter remarks'
                            style={{ marginTop: '15px', width: '90%' }}
                        />
                        <Text strong style={{ marginTop: '20px', marginBottom: '0px' }}>Are you sure want to mark this order as Refunded?</Text>
                    </div>
                </Modal>
            </Container >
        </div>
    )
}

export default withDefaultLayout(PoojaOrders)
